import { Link } from 'react-router-dom';
import { stats } from '@/mocks/cases';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20golden%20world%20map%20with%20glowing%20connection%20lines%20on%20dark%20elegant%20background%20modern%20corporate%20style%20warm%20tones%20professional%20atmosphere&width=1800&height=900&seq=hero-bg-2025&orientation=landscape"
          alt="征途国际 全球服务"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-24 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-6">
            全球征途，无限可能
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            征途国际为您提供一站式国际化服务，涵盖全球市场拓展、跨境业务合作与国际资源对接。无论您的征途目标在哪里，征途国际都是您走向世界的最强合作伙伴。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/services"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              了解我们的服务
            </Link>
            <Link
              to="/about#contact"
              className="px-8 py-3 border border-background-50/30 text-background-50 font-medium rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              立即咨询
            </Link>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pb-12">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50/10 backdrop-blur-sm border border-background-50/15 rounded-lg p-4 md:p-5 text-center"
            >
              <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                <i className={`${stat.icon} text-primary-400 text-lg`}></i>
              </div>
              <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}